function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TotalMatchComponent from '@/apps/audiences/components/TotalMatchComponent.vue';
import { useCaseListMixin } from '@/apps/attributes/mixins/use_case_list_mixin';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import tasks from '@/js/tasks';
import { mapState, mapMutations } from 'vuex';
import { ARRAY_TYPE_ELEMENTS, TYPE_ELEMENTS, ROLES_LIST, GA_EVENTS } from '@/js/constants';
export default {
  name: 'ProductizeUseCaseDigitalAudiencesPage',
  components: {
    TotalMatchComponent: TotalMatchComponent
  },
  mixins: [useCaseListMixin],
  data: function data() {
    return {
      valid: true,
      edit: true,
      item: null,
      dataToExport: {},
      IDSInfo: {},
      segments: [],
      processDates: [],
      isValidated: false,
      warningMessage: '',
      keyPrevisualize: 1
    };
  },
  created: function created() {
    var params = {
      user: this.userEmail
    };
    this.getUseCasesByStatus(this.companyCode, '3', params);
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode'])), {}, {
    rules: function rules() {
      var _this = this;
      return {
        useCase: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        segment: [function (v) {
          return !!v || _this.translate('reglas.field');
        }],
        segmentProcessDate: [function (v) {
          return !!v || _this.translate('reglas.field');
        }]
      };
    },
    hasIDSInfo: function hasIDSInfo() {
      console.log(Object.keys(this.IDSInfo));
      return Object.keys(this.IDSInfo).length > 0;
    }
  }),
  methods: {
    onValidate: function onValidate() {
      var _this2 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      var body = _objectSpread({}, this.dataToExport);
      var params = {
        preview: '1'
      };
      UseCasesService.exportSandboxToDigitalAudiences(this.companyCode, this.item.id, params, body).then(function (response) {
        if (response) {
          var responseData = response.data;
          _this2.IDSInfo = {
            records: responseData.records,
            duplicated: responseData.duplicates,
            'not-found': responseData['not-found']
          };
          _this2.isValidated = _this2.IDSInfo.duplicated === 0;
          if (!_this2.isValidated) {
            _this2.warningMessage = "No se puede exportar el Sandbox porque existen (".concat(_this2.IDSInfo.duplicated, ") IDs duplicados. Se recomienda validar la l\xF3gica de creaci\xF3n de la agrupaci\xF3n y voler a intentar.");
          }
          _this2.keyPrevisualize += 1;
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      var params = _objectSpread({}, this.dataToExport);
      UseCasesService.exportSandboxToDigitalAudiences(this.companyCode, this.item.id, {}, params).then(function (response) {
        if (response && response.success === true) {
          if (_this3.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.EXPORT_AUDIENCE,
              segment: _this3.dataToExport.segment,
              company_code: _this3.companyCode,
              hash_email: _this3.stringToHash(userInfo.email),
              module: 'attributes_marketplace'
            });
          }
          var message = _this3.translate('success_messages.export_sandox');
          tasks.toast.success(message, _this3.translate('titles.success'));
          _this3.$router.push({
            name: 'productize_model'
          });
        }
      });
    },
    onUseCaseSelected: function onUseCaseSelected() {
      var _this4 = this;
      if (this.item) {
        UseCasesService.getSandboxSegmentFields(this.item.project_sand, this.item.dataset_sand, 'sand_segment_proposal').then(function (response) {
          if (response.data) {
            _this4.segments = response.data.segment || [];
          }
        });
      }
      UseCasesService.getTablePartitionField(this.item.project_sand, this.item.dataset_sand, 'sand_segment_proposal').then(function (response) {
        if (response.data) {
          _this4.processDates = response.data.partition_info.values;
        }
      });
    }
  }
};